/* @flow */

import * as React from 'react';

import { connect } from 'react-redux';

import { selectCartUUID as selectCartId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { Button, Base, Svg } from '@gandi/ui';
// Will need to get migrated, probaly AddonButton.
// eslint-disable-next-line @gandi/gandi/no-private-import
import { CloseButton } from '@gandi/ui/private';

import type { FullState } from '../../../types';

import { stringify } from './helpers';

import type { CartProductSuggestion } from './types';

import styles from './ReferAFriendOffer.scss';

export type OwnProps = {
  offer: CartProductSuggestion,
  onDismissClick: (evt: SyntheticMouseEvent<>) => mixed,
  dismissLabel: string,
};

export type StateProps = {
  cartId: string,
};

export type Props = {
  ...OwnProps,
  ...StateProps,
};

function ReferAFriendOffer(props: Props): React.Node {
  const {
    cartId,
    offer: { reason, payload },
    dismissLabel,
    onDismissClick,
  } = props;
  const translator = useTranslator();
  const { __ } = translator;

  const title = __(
    'Get 75%% off your Simple Hosting S+ instance for 6 months thanks to our Refer a Friend referral program.',
  );
  const description = __(
    '<a target="_blank" rel="noopener" href="https://docs.gandi.net/en/billing/means_of_payment/refer_a_friend.html">' +
      'Read more about the referral program' +
      '</a>',
    { withHTML: true },
  );

  const params = {
    cross_sell: 1,
    reason,
    ...payload,
  };
  const queryString = stringify(params);

  const to = `/simplehosting/create/${String(cartId)}${queryString}`;

  return (
    <Base flex flexAlignItemsStart marginBottom="base" className={styles.root}>
      <Base paddingTop="small" paddingRight="xsmall" paddingLeft="small">
        <Svg name="gift" theme="green" className={styles.icon} />
      </Base>
      <Base
        flex
        flexWrap
        flexJustifyBetween
        paddingTop="small"
        paddingRight="small"
        paddingBottom="small"
        className={styles.wrapper}
      >
        <Base flex flexAlignItemsStart>
          <div className={styles.content}>
            <Base tagName="h3" margin="none" className={styles.title}>
              {title}
            </Base>
            <Base tagName="p" margin="none">
              <span dangerouslySetInnerHTML={description} />
            </Base>
          </div>
        </Base>
        <Button kind="outline" to={to}>
          <span>
            <span aria-hidden>+ </span> {__('Add to cart')}
          </span>
        </Button>
      </Base>
      <CloseButton
        translator={translator}
        onClick={onDismissClick}
        label={dismissLabel}
        className={styles.close}
      />
    </Base>
  );
}

const mapStateToProps = (state: FullState): StateProps => ({
  cartId: selectCartId(state),
});

// $FlowFixMe[signature-verification-failure]
// $FlowFixMe[underconstrained-implicit-instantiation]
export default connect(mapStateToProps)(ReferAFriendOffer);
